import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useSFX } from 'js/hooks/useSFX';
// import selectors
import { getTranslationById } from 'js/store/app/App.selectors';

// import icons
import IconNavHome from 'js/components/icon/Icon.nav-home';
import IconNavSearch from 'js/components/icon/Icon.nav-search';
import IconNavCollections from 'js/components/icon/Icon.nav-collections';
import IconNavLibrary from 'js/components/icon/Icon.nav-library';
import { trackEvent } from '../../utils/tracking';

const SPRING_TRANSITION = {
  duration: 0.75,
  type: 'spring',
  bounce: 0.4,
};

const navLinks = [
  {
    id: 'nav_item_home',
    url: '/',
    icon: <IconNavHome />,
    className: 'nav__item--home',
    trackingEvent: 'game_home_click',
  },
  {
    id: 'nav_item_find',
    url: '/find',
    icon: <IconNavSearch />,
    className: 'nav__item--find',
    trackingEvent: 'game_find_click',
  },
  {
    id: 'nav_item_collections',
    url: '/collections',
    icon: <IconNavCollections />,
    className: 'nav__item--collections',
    trackingEvent: 'game_collections_click',
  },
  {
    id: 'nav_item_library',
    url: '/library',
    icon: <IconNavLibrary />,
    className: 'nav__item--library',
    trackingEvent: 'game_library_click',
  },
];

const SectionNav = () => {
  const homeText = useSelector((state) => getTranslationById(state, 'nav_item_home', 'Home Feed'));
  const findText = useSelector((state) => getTranslationById(state, 'nav_item_find', 'Quick Find'));
  const collectionsText = useSelector((state) => getTranslationById(state, 'nav_item_collections', 'Collections'));
  const libraryText = useSelector((state) => getTranslationById(state, 'nav_item_library', 'My Library'));
  const { playSFX } = useSFX();

  const activityCardFocus = useSelector((state) => state.app.activityCardFocus);

  const [hide, setHide] = useState(false);

  useEffect(() => {
    setHide(activityCardFocus);
  }, [activityCardFocus]);

  const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

  return (
    <motion.nav
      key={'navigation'}
      initial={{ y: 0, x: '-50%' }}
      animate={{ x: '-50%', y: hide ? 110 : 10 }}
      transition={SPRING_TRANSITION}
      className={'section--nav' + (isStandalone ? ' section--nav--standalone' : '')}
    >
      <ul>
        {navLinks.map((item, index) => (
          <li key={index} className={`nav__item ${item.className}`}>
            <NavLink
              to={item.url}
              onClick={() => {
                trackEvent(item.trackingEvent);
                playSFX('button_tap');
              }}
            >
              {item.icon}
              {item.id === 'nav_item_home' && homeText}
              {item.id === 'nav_item_find' && findText}
              {item.id === 'nav_item_collections' && collectionsText}
              {item.id === 'nav_item_library' && libraryText}
            </NavLink>
          </li>
        ))}
      </ul>
    </motion.nav>
  );
};

export default SectionNav;
